import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_back",
  "use": "arrow_back-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"arrow_back\"><path d=\"m32.75 44-20-20 20-20 2.8 2.85L18.4 24l17.15 17.15Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol